export default __webpack_public_path__ + "static/media/logo.8faaa6f1.png";